'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';

const REDIRECT_SECONDS = 5;

export default function NotFound() {
  const pathname = usePathname();
  const [secondsLeft, setSecondsLeft] = useState(REDIRECT_SECONDS);

  useEffect(() => {
    const ref = `404 ${pathname}`;
    const target = `/?ref=${encodeURIComponent(ref)}`;

    const interval = setInterval(() => {
      setSecondsLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    const timeout = setTimeout(() => {
      window.location.replace(target);
    }, REDIRECT_SECONDS * 1000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4">
      <div className="max-w-md text-center">
        <h1 className="text-6xl font-bold text-foreground">404</h1>
        <h2 className="mt-4 text-2xl font-semibold text-foreground">Page not found</h2>
        <p className="mt-2 text-muted-foreground">
          We couldn&apos;t find{' '}
          <span className="font-mono text-foreground">{pathname}</span>
        </p>
        <p className="mt-6 text-sm text-muted-foreground">
          Redirecting to home in{' '}
          <span className="font-semibold text-foreground">{secondsLeft}</span>{' '}
          second{secondsLeft === 1 ? '' : 's'}...
        </p>
      </div>
    </div>
  );
}
